// extracted by mini-css-extract-plugin
export default {"preview-empty":"EmptyPreviews-module__preview-empty___JRiho"};